var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth__wrapper"},[_c('AuthSide'),_c('div',{staticClass:"auth__main"},[_c('AuthHeader'),_c('router-view'),_c('Loader')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }